import React, { Component as C } from "react"
import PropTypes from "prop-types"
import { omit } from "lodash"

import classnames from "classnames"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import styles from "./index.less"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "../variables.less"
import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

class IconButton extends C {
  static dynamicStyles = null
  static displayName = "IconButton"

  static propTypes = {
    icon: PropTypes.string.isRequired,
    iconClassName: PropTypes.string,
    type: PropTypes.string,
  }

  static defaultProps = {
    type: "default",
  }

  constructor(props) {
    super(props)

    if (IconButton.dynamicStyles == null) {
      const dynamicStylesConfig = toJss(props.skinObject.iconButton || {}, {
        button: {
          link: {
            color: cv.blue300,
          },
          error: {
            color: v.buttonErrorColor,
          },
          success: {
            color: v.buttonSuccessColor,
          },
          pm_focus: {
            link: {
              color: darken(15, cv.blue300),
            },
            error: {
              color: darken(3, v.buttonErrorColor),
            },
            success: {
              color: darken(3, v.buttonSuccessColor),
            },
          },
          pm_hover: {
            link: {
              color: darken(15, cv.blue300),
            },
          },
        },
      })

      IconButton.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  getTypeClass() {
    let { classes } = IconButton.dynamicStyles

    var types = {
      success: classes.success,
      error: classes.error,
    }

    var type = types[this.props.type]

    return type
  }

  render() {
    let { classes } = IconButton.dynamicStyles
    let iconClass = classnames(styles.icon, this.props.iconClassName, this.getTypeClass())
    let linkClass = classnames(styles.link, classes.link)

    let content = [
      <Icon key={`icon${this.props.icon}`} icon={this.props.icon} className={iconClass} />,
      <span key={`link${this.props.icon}`} className={linkClass}>
        {this.props.children}
      </span>,
    ]

    let buttonClass = classnames(styles.button, classes.button, {
      [styles.disabled]: this.props.disabled,
    })

    let controlType = this.props.controlType || "button"
    let buttonProps = omit(this.props, ["dataQa", "skinObject"]) //TODO: refactor to white list

    if (controlType === "button") {
      return (
        <button {...buttonProps} className={buttonClass} data-qa={this.props.dataQa}>
          {content}
        </button>
      )
    }

    if (controlType === "link") {
      return (
        <a {...buttonProps} className={buttonClass} data-qa={this.props.dataQa}>
          {content}
        </a>
      )
    }
  }
}

export default withSkin(IconButton)
